import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';

const differentials: string[] = [
  'Pró escola. Não pró fisco.',
  'Parceiro estratégico, não só jurídico.',
  'Acesso direto. Resposta ágil.',
  'Visão jurídica e contábil integrada.',
  'Um escritório que acompanha o ritmo do setor.',
];

export function WhyEducaLegalTeaser() {
  return (
    <section className="relative py-16 md:py-20 bg-orange-50/30 border-y border-orange-200">
      <div className="section-container">
        {/* Header — alinhado à esquerda, sem subtítulo */}
        <motion.div
          className="max-w-2xl mb-10 md:mb-12"
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-48px' }}
          transition={{ duration: 0.55 }}
        >
          <div className="flex items-center gap-3 mb-5">
            <motion.span
              className="h-px bg-orange origin-left"
              initial={{ scaleX: 0 }}
              whileInView={{ scaleX: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.1 }}
              style={{ width: 40 }}
            />
            <span className="text-caption font-semibold uppercase tracking-[0.22em] text-neutral-700">
              Por que a Educa Legal
            </span>
          </div>
          <h2 className="text-display-sm md:text-display-md font-bold text-neutral-950 leading-tight tracking-tight">
            Mais que jurídico — parceiro estratégico da sua escola.
          </h2>
        </motion.div>

        {/* Lista vertical minimalista */}
        <ul className="border-t border-orange-200 mb-10">
          {differentials.map((title, i) => (
            <motion.li
              key={title}
              className="group border-b border-orange-200"
              initial={{ opacity: 0, y: 8 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-32px' }}
              transition={{ duration: 0.4, delay: 0.1 + i * 0.05 }}
            >
              <div className="flex items-baseline gap-6 md:gap-10 py-4 md:py-5">
                <span className="text-caption font-semibold tabular-nums tracking-widest text-neutral-400 w-8 flex-shrink-0">
                  {String(i + 1).padStart(2, '0')}
                </span>
                <h3 className="flex-1 text-body-md md:text-heading-md font-medium text-neutral-950 leading-snug transition-colors group-hover:text-orange-700">
                  {title}
                </h3>
              </div>
            </motion.li>
          ))}
        </ul>

        {/* CTA minimalista */}
        <motion.div
          initial={{ opacity: 0, y: 8 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.4, delay: 0.45 }}
        >
          <Link
            to="/sobre-nos#diferenciais"
            className="group inline-flex items-baseline gap-2 text-body-sm font-semibold uppercase tracking-wider text-neutral-700 hover:text-orange-700 transition-colors"
          >
            Conheça todos os diferenciais
            <ArrowRight
              size={14}
              className="transition-transform duration-200 group-hover:translate-x-1"
            />
          </Link>
        </motion.div>
      </div>
    </section>
  );
}
